var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"w-screen fixed inset-0 h-screen flex items-center justify-center text-neutral-600 text-2xl uppercase bg-white"},[_c('p',{domProps:{"textContent":_vm._s(_vm.loadingMessage)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }